import React, { useState, useEffect } from "react";

import TabelaItensPedido from "./TabelaItensPedido";
import axios from "axios";
import { Modal } from 'react-bootstrap';

import { URL_PAGAMENTO } from "../../config/urls";

function formatarMoedaBr(value) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export default function TabelaPedidosFormando(props) {

  const [pedido, setPedido] = useState(null);
  const [confirmarCancelamento, setConfirmarCancelamento] = useState(false);
  const [processandoCancelamento, setProcCancelamento] = useState(false);

  useEffect(() => {
    if (pedido != null) {
      props.data.forEach(p => {
        if (p.pedido == pedido.pedido) {
          setPedido(p);
        }
      });
    }
  }, [props.data]);

  const cancelarPedido = () => {
    setProcCancelamento(true);
    axios.delete(`${URL_PAGAMENTO}/administracao/pedido/cancelar/${pedido.pedido}/1`, {
      headers: {
        "Authorization": "Bearer "+localStorage.getItem("tokenPagamento")
      }
    }).then((response) => {
      alert(`Pedido ${pedido.pedido} foi cancelado.`);
      props.atualizarPedidosFormando();
      setConfirmarCancelamento(false);
    }).catch((err) => {
      alert("Não foi possível cancelar o pedido. Tente novamente!");
    }).finally(() => {
      setProcCancelamento(false);
    });
  }

  return (
    <div>
      <div className="table-responsive fixed">
        <table className="table table-bordered table-striped">
          <thead>
          <tr>
            <th>Id</th>
            <th>Tipo de pagamento</th>
            <th>Valor total</th>
            <th>Valor pago</th>
          </tr>
          </thead>
          <tbody>
          {
            props.data.length > 0 ?
              props.data.map((pedido, i) =>
                <tr key={i} style={{ cursor: "pointer" }} onClick={() => { setPedido(pedido) }}>
                  <td>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                      #{pedido.pedido}
                      <button type="button" style={{ padding: 0, fontSize: 10 }} className="btn btn-link">Clique para abrir o pedido</button>
                    </div>
                  </td>
                  <td>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      {pedido.cobranca.formaPagamento}
                      {
                        pedido.status === "Pedido cancelado" ?
                          <span style={{ backgroundColor: "#dd4b39", borderRadius: 25, padding: "5px 10px", fontSize: 8, fontWeight: "bolder", color: "white" }}> CANCELADO</span>
                          : pedido.status === "Pedido em cancelamento" ?
                            <span style={{ backgroundColor: "#f39c12", borderRadius: 25, padding: "5px 10px", fontSize: 8, fontWeight: "bolder", color: "white" }}> CANCELAMENTO SOLICITADO</span>
                            : null
                      }
                    </div>
                  </td>
                  <td>{formatarMoedaBr(pedido.cobranca.valor)}</td>
                  <td>{formatarMoedaBr(pedido.cobranca.valorJaPago)}</td>
                </tr>
              )
              : <tr><td colSpan={4} style={{ textAlign: "center" }}>Este formando não realizou nenhuma compra</td></tr>
          }
          </tbody>
        </table>
      </div>

      {
        pedido != null ?
          <div>
            <div>
              <h4>Pedido {pedido.pedido}</h4>
            </div>
            <div>
              {
                pedido.status !== "Pedido cancelado" ?
                  <div style={{marginBottom: '10px'}}>
                    <button onClick={() => { setConfirmarCancelamento(true) }} className="btn btn-danger"><i class="fa fa-shopping-cart"></i> Cancelar pedido</button>
                  </div>
                  :
                  ''
              }
              <TabelaItensPedido pedidoSelecionado={pedido} />
            </div>
          </div>
          :
          ''
      }

      {
        pedido != null ?
          <Modal show={confirmarCancelamento} onHide={() => setConfirmarCancelamento(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Cancelar pedido</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Você tem certeza que quer cancelar este pedido {pedido.pedido}? Essa ação não poderá ser desfeita.
            </Modal.Body>
            <Modal.Footer>
              <button onClick={() => setConfirmarCancelamento(false)} disabled={processandoCancelamento} className="btn btn-link btn-flat">Cancelar</button>
              <button onClick={() => { cancelarPedido() }} disabled={processandoCancelamento} className="btn btn-danger btn-flat">
                {processandoCancelamento ? <span><i className="fa fa-spinner fa-spin"></i> Cancelando</span> : "Cancelar pedido"}
              </button>
            </Modal.Footer>
          </Modal>
          :
          ''
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/pedidosFormando/TabelaPedidosFormando.js